module.exports = __webpack_public_path__ + "3fc726099d0817567e0846aa6903bfe3.svg";